import { useCallback } from 'react';

import { IReturnedCheckDetailsCheckTypeEnum } from '@/dtos';
import { LockboxStatus } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

interface Result {
  status?: string;
  statusTitle?: string;
}

const useGetReturnCheckStatus = () => {
  const { originalLockbox } = useLockboxDetailsStore();

  const getReturnCheckStatus = useCallback((): Result => {
    if ((originalLockbox?.lockboxStatus === LockboxStatus.APPROVED || originalLockbox?.lockboxStatus === LockboxStatus.PROCESSING)
      && originalLockbox?.details?.processingDecision?.type === LockboxStatus.VOID) {
      return { status: LockboxStatus.VOID, statusTitle: 'Voided'};
    }

    if ((originalLockbox?.lockboxStatus === LockboxStatus.APPROVED
      || originalLockbox?.lockboxStatus === LockboxStatus.PROCESSING
      || originalLockbox?.lockboxStatus === LockboxStatus.COMPLETED)
      && originalLockbox?.details?.processingDecision?.type === LockboxStatus.REISSUE) {
      return { status: LockboxStatus.REISSUE, statusTitle: 'Reissued'};
    }

    if ((originalLockbox?.lockboxStatus === LockboxStatus.APPROVED
      || originalLockbox?.lockboxStatus === LockboxStatus.PROCESSING
      || originalLockbox?.lockboxStatus === LockboxStatus.COMPLETED)
      && originalLockbox?.details?.checkType === IReturnedCheckDetailsCheckTypeEnum.PARTICIPANT) {
      return { status: LockboxStatus.PROCESS, statusTitle: 'Processed'};
    }

    return { status: originalLockbox?.lockboxStatus, statusTitle: originalLockbox?.lockboxStatus };
  }, [
    originalLockbox?.lockboxStatus,
    originalLockbox?.details?.processingDecision?.type,
    originalLockbox?.details?.checkType,
  ]);

  return { getReturnCheckStatus };
};

export default useGetReturnCheckStatus;
